import * as React from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../../assets/css/scss/section/player/_profileGallerySection.scss";
import { Fragment, useEffect, useState } from "react";
import preventRightClick from "../../../common/preventRightClick";
// const photos = [
//     {
//         src: "/assets/gallery-images/image1_original.jpg",
//         width: 5,
//         height: 2,
//         title: "kel------",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image14_original.jpg",
//         width: 5,
//         height: 2,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image3_original.jpg",
//         width: 6,
//         height: 4,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image4_original.jpg",
//         width: 6,
//         height: 4,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image5_original.jpeg",
//         width: 6,
//         height: 4,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image6_original.jpeg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image7_original.jpg",
//         width: 3,
//         height: 4,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image8_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image10_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image35_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image11_original.jpg",
//         width: 6,
//         height: 3,
//         title: "kel",
//     },
//     {
//         src: "/assets/gallery-images/image12_original.jpg",
//         width: 6,
//         height: 4,
//         title: "kel",
//         caption: "test",
//     },

//     {
//         src: "/assets/gallery-images/image15_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },

//     {
//         src: "/assets/gallery-images/image17_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image18_original.jpg",
//         width: 3,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image16_original.jpg",
//         width: 4,
//         height: 4,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image19_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image20_original.jpeg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image21_original.jpg",
//         width: 6,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image22_original.jpg",
//         width: 10,
//         height: 5,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image23_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },

//     {
//         src: "/assets/gallery-images/image25_original.jpg",
//         width: 4,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image26_original.jpg",
//         width: 6,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image27_original.jpg",
//         width: 6,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
//     {
//         src: "/assets/gallery-images/image28_original.jpg",
//         width: 6,
//         height: 3,
//         title: "kel",
//         caption: "test",
//     },
// ];

export default function ProfileGallerySection(props: any) {
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [photos, setPhotos] = useState([]);

    const openLightbox = React.useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    useEffect(() => {
        if (props?.data) {
            const data: any = []
            props?.data.map((imgData: any) => {
                data.push({
                    "src": imgData,
                    "width": 2,
                    "height": 2
                })
            })
            setPhotos(data)
        }
    }, [props])

    return (
        <div className="profile-gallery-section theme-bg-white">
            <div className="image-section" onContextMenu={(e) => preventRightClick(e)}>
                {photos.length ?
                    <Fragment>
                        <Gallery photos={photos} onClick={openLightbox} margin={5} />
                        {/* <ModalGateway>
                            {viewerIsOpen ? (
                                <Modal onClose={closeLightbox}>
                                    <Carousel
                                        currentIndex={currentImage}
                                        views={photos.map((x: any) => ({
                                            ...x,
                                            srcset: x.srcSet,
                                            caption: x.title,
                                        }))}
                                    />
                                </Modal>
                            ) : // </>
                                null}
                        </ModalGateway> */}
                    </Fragment>
                    : null}
            </div>
        </div >
    );
}
